import { render, staticRenderFns } from "./DropdownSortList.vue?vue&type=template&id=6cc8493c&scoped=true&"
import script from "./DropdownSortList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DropdownSortList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DropdownSortList.vue?vue&type=style&index=0&id=6cc8493c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8493c",
  null
  
)

export default component.exports